import React from 'react'
// ##
import CompaniesTable from '../../modules/Company/components/CompaniesTable'

export default function CompanyPage() {
  return <CompaniesTable />
}
